(() => {
  const hostSelector = 'ruffruff-order-bonus-app';
  const buttonSelector = '.rob-floating-button';
  const badgeSelector = '.rob-floating-button__badge';
  const openPanelSelector = '.rob-panel--open';

  let hasOpenedOnCurrentPage = false;
  let currentUrl = window.location.href;
  let retryTimer = null;
  let documentObserver = null;
  const observedRoots = new WeakSet();

  const resetPageStateIfUrlChanged = () => {
    if (currentUrl === window.location.href) return;

    currentUrl = window.location.href;
    hasOpenedOnCurrentPage = false;
  };

  const getWidgetRoot = () => {
    const host = document.querySelector(hostSelector);
    return host && host.shadowRoot ? host.shadowRoot : null;
  };

  const isVisible = (element) => {
    if (!element) return false;

    const rect = element.getBoundingClientRect();
    const styles = window.getComputedStyle(element);

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      styles.opacity !== '0'
    );
  };

  const hasUnacquiredCampaign = (root) => {
    const badge = root.querySelector(badgeSelector);
    if (!badge) return false;

    const badgeCount = Number.parseInt((badge.textContent || '').trim(), 10);
    return Number.isFinite(badgeCount) && badgeCount > 0;
  };

  const observeWidgetRoot = (root) => {
    if (!root || observedRoots.has(root) || !window.MutationObserver) return;

    const observer = new MutationObserver(() => {
      scheduleOpenAttempt();
    });

    observer.observe(root, {
      childList: true,
      subtree: true,
    });

    observedRoots.add(root);
  };

  const tryOpenWidget = () => {
    resetPageStateIfUrlChanged();

    if (hasOpenedOnCurrentPage) return true;

    const root = getWidgetRoot();
    if (!root) return false;

    observeWidgetRoot(root);

    if (root.querySelector(openPanelSelector)) {
      hasOpenedOnCurrentPage = true;
      return true;
    }

    if (!hasUnacquiredCampaign(root)) return false;

    const button = root.querySelector(buttonSelector);
    if (!isVisible(button)) return false;

    button.click();
    hasOpenedOnCurrentPage = true;
    return true;
  };

  const scheduleOpenAttempt = () => {
    window.clearTimeout(retryTimer);
    retryTimer = window.setTimeout(() => {
      tryOpenWidget();
    }, 100);
  };

  const initObserver = () => {
    if (!window.MutationObserver || documentObserver) return;

    documentObserver = new MutationObserver(() => {
      scheduleOpenAttempt();
    });

    documentObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  const init = () => {
    initObserver();

    scheduleOpenAttempt();
    window.setTimeout(tryOpenWidget, 500);
    window.setTimeout(tryOpenWidget, 1500);
    window.setTimeout(tryOpenWidget, 3000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      hasOpenedOnCurrentPage = false;
    }

    resetPageStateIfUrlChanged();
    scheduleOpenAttempt();
  });
})();
